/**
 * @Description 组件 SubVideo 视频播放
 * @Author
 * @Date
 */
/* HTML */
<template>
	<section style="height: 100%;width: 100%;">
		<div v-if="$checkEmpty(info)" class="flex-center sub-video-none"></div>
		<!--<div v-if="$checkEmpty(info)" class="none-map-item"><img alt="暂无视频" title="暂无视频" src="@/static_dazzle/images/data_none.png" ></div>-->
		<div v-else-if="$checkEmpty(info.sipServerAddr) || $checkEmpty(info.sipAuthId) || $checkEmpty(info.sipVideoId)" class="flex-center sub-video-noauth">暂未开通</div>
		<video v-if="!($checkEmpty(info) || $checkEmpty(info.sipServerAddr) || $checkEmpty(info.sipAuthId) || $checkEmpty(info.sipVideoId))" :id="vEleId" :controls="controlsFlag"></video>
	</section>
</template>

/* JS */
<script>
	// 组件 播放视频
	import JSWebrtc from '@/static_dazzle/plugins/h5s/jswebrtc.min';

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date
		 */
		name: "SubVideo",

		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date
		 */
		components: {}, // components

		/**
		 * @Des 属性值
		 * @Auth
		 * @Date
		 */
		props: {
			/**
			 * @Des video 控制器
			 * @Auth
			 * @Date
			 */
			controls: {
				type: Boolean,
				default: function() {
					return true;
				}
			},
			/**
			 * @Des video id
			 * @Auth
			 * @Date
			 */
			vEleId: {
				type: String,
				default: function() {
					return 'video-webrtc_' + new Date().getTime();
				}
			},
			/**
			 * @Des video info
			 * @Auth
			 * @Date
			 */
			vInfo: {
				type: Object,
				default: function() {
					return {};
				}
			},
		}, // props

		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date
		 */
		data() {
			return {
				// info
				info: {},
				// 记录播放器
				player: null,
				// flag 控制器
				controlsFlag: this.controls,
			} // return
		}, // data

		/**
		 * @Des 初始化
		 * @Auth
		 * @Date
		 */
		created() {

		}, // created

		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date
		 */
		mounted() {

			this.info = Object.assign({}, this.vInfo);
			this.$nextTick(() => {
				// 初始化video
				this.initVideo();
			})

		}, // mounted

		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date
		 */
		beforeDestroy() {

		}, // beforeDestroy

		/**
		 * @Des 销毁
		 * @Auth
		 * @Date
		 */
		destroyed() {

		}, // destroyed

		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date
		 */
		methods: {

			/**
			 * @Des 解析数据 初始化video
			 * @Auth
			 * @Date
			 */
			initVideo() {
				// 空值 中止
				if(
					this.$checkEmpty(this.vInfo) ||
					this.$checkEmpty(this.vInfo.sipServerAddr) ||
					this.$checkEmpty(this.vInfo.sipAuthId) ||
					this.$checkEmpty(this.vInfo.sipVideoId)
				) return false;

				var video = document.getElementById(this.vEleId);
				var url = 'webrtc://' + this.vInfo.sipServerAddr + '/live/' + this.vInfo.sipAuthId + '@' + this.vInfo.sipVideoId;

				// 控制器
				this.controlsFlag = true;

				if(this.player == null) {
					this.player = new JSWebrtc.JSWebrtc.Player(url, {
						video: video,
						autoplay: true,
						onPlay: (obj) => {
							// 隐藏控制器
							this.controlsFlag = this.controls;
							console.log(this.vEleId, 'webrtc', "start play");
						}
					});
				} else {
					this.player.destroy();
					this.player.setParams(url, {
						video: video,
						autoplay: true,
						onPlay: (obj) => {
							// 隐藏控制器
							this.controlsFlag = this.controls;
							console.log(this.vEleId, 'webrtc', "start play", 'change');
						}
					});
				}
			}, // initVideo

		}, // methods

		/**
		 * @Des 监听
		 * @Auth
		 * @Date
		 */
		watch: {
			/**
			 * @Des 监听 数据改变
			 * @Auth
			 * Date
			 */
			vInfo: {
				handler(newVal, oldVal) {
					this.info = {};
					// 延迟执行
					this.$nextTick(() => {
						this.info = Object.assign({}, this.vInfo);
						this.$nextTick(() => {
							// 初始化video
							this.initVideo();
						})
					}); // $nextTick
				},
				immediate: false, // 第一次赋值 监听
				deep: true, // 深入监听
			},
			controls: {
				handler(newVal, oldVal) {
					// flag 控制器
					this.controlsFlag = this.controls;
				},
				immediate: true, // 第一次赋值 监听
				deep: true, // 深度监听
			}
		}, // watch

		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date
		 */
		computed: {}, // computed

	} // export default
</script>

/* CSS */
<style src="@/components/SubVideo/sub-video-style.scss" lang="scss" scoped></style>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/SubVideo/SubVideo.vue